// extracted by mini-css-extract-plugin
export default {"TextBlock":"TextBlock_TextBlock__DfRkv","TextBlockTitle":"TextBlock_TextBlockTitle__YezAa","TextBlockParagraph":"TextBlock_TextBlockParagraph__3t3dq"};